// features/drive/components/Toolbar/Toolbar.styles.js

import styled from 'styled-components';

export const ToolbarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const LeftSection = styled.div`
  flex: 1;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ViewToggle = styled.div`
  display: flex;
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: 8px;
  overflow: hidden;
`;

export const ToggleButton = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  background: ${({ $active, theme }) => ($active ? theme.landing.buttonBg : theme.landing.cardBg)};

  color: ${({ $active }) => ($active ? '#fff' : 'var(--color-text-secondary)')};

  transition: 0.2s;

  &:hover {
    background: ${({ theme }) => theme.landing.buttonHover};
    color: #fff;
  }
`;
